<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import upprocess from "../../../../common/upProcess/index.vue";
import uploadFile from "../../../../common/uploadFile/index.vue";
import updateywkm from "../../../../common/updateywkm/index.vue";
import { dkdj_importExcel } from "../../../../../api/dkdj.js";
import config from "../../../../../../configHttp.js";
import {importTaxOfficeTemplate} from "../../../../../api/sjmb";
export default {
  components: {
    upprocess,
    uploadFile,
    updateywkm,
  },
  data: function () {
    return {
      uptype: 1,
      importType: "0",
      mboptions: getdata().mboptions,
      count: 5,
      successdata: { successCount: 0, errorCount: 0 },
      batchNum: "",
      timer: null,
      upformdata: {}, //文件信息
    };
  },
  methods: {
    forbackup() {
      this.$refs["uploadfileRef"].forrefresh();
      this.uptype = 1;

      clearInterval(this.timer);
    },
    forchooseindex(index) {
      this.$emit("forchooseindex", index);
    },
    toCustomTemplate() {
      this.$router.push("/CustomTemplate");
    },
    getuploadparams(e) {
      this.upformdata = e;
      // 获取到的文件信息
    },
    fordownloadmb() { //模板下载
      let fileName;
      let url;
      let fileType;
      if (this.importType === "2") {
        fileName = "税局导入模板";
        url = "dataAcquisition/template/download";
        fileType = "xlsx";
      } else {
        fileName = "代扣代缴凭证明细表导入模板";
        url = "dkdj/template/download";
        fileType = "xls";
      }
      let params = {
        downUrl: config.baseURL + url,
        typeObj: {
          toForm: false,
          fileName: fileName,
          fileType: fileType,
          failUrl: this.$winURl
        },
      };
      this.$downloadcommon(params);
    },
    //提交
    importIinvExcel() {
      this.count = 5;
      if (this.$emptyandnull(this.upformdata.upfile)) {
        this.$message.error("请选择要上传的文件");
        return false;
      }
      let formData = {
        importType: this.importType,
        file: this.upformdata.upfile,
      };
      if (this.importType === "2") {
        importTaxOfficeTemplate(formData).then(res => {
          if (!res.data.data.DKDJ) {
            this.$message.error("当前导入文件没有代扣代缴数据");
            return false;
          }
          this.importResultHandle(res.data.code, res.data.data.DKDJ.batchNo, res.data.data.DKDJ, res.data.msg);
        })
      } else {
        dkdj_importExcel(formData).then((res) => {
          this.importResultHandle(res.data.code, res.data.data.batchNo, res.data.data, res.data.msg);
        });
      }
    },
    importResultHandle(code, batchNum, successdata, errMsg) {
      if (code == 1) {
        //如果成功数量为0则跳转至结果页面
        if (successdata.successCount == 0 || !successdata.successCount) {
          this.$message.error(
              "当前导入文件成功条数为0，具体错误信息可到上传结果界面查看"
          );
        } else {
          this.uptype = 2;
          this.batchNum = batchNum;
          this.successdata.successCount = successdata.successCount;
          this.successdata.errorCount = successdata.errorCount;
          this.timer = setInterval(() => {
            this.count--;
            if (self._isDestroyed) {
              clearInterval(this.timer);
              return false;
            }
            if (this.count == 0) {
              this.$refs["uploadfileRef"].forrefresh();
              this.uptype = 1;
              clearInterval(this.timer);
            }
          }, 1000);
        }
      } else {
        this.$message.error(errMsg);
      }
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
